import { ThemeProvider } from "@mui/material/styles";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import VendorProfilePage from "./app/vendorProfile";
import SnackbarAlert from "./components/snackbar";
import { setUserData } from "./redux/slices/Login";
import { ADMIN_ROUTES, AuthRoutes } from "./routes";
import { AuthLayout } from "./routes/AuthLayout";
import { ProtectedLayout } from "./routes/ProtectedLayout";
import MUI_THEME from "./theme";
import { constants } from "./theme/Variables";
import EditReturn from "./app/returnOrders/EditReturn";
import SupportScreen from "./Support";
import PrivacyPolicyPage from "./app/privacyPolicy";

function App() {
  const dispatch = useDispatch();
  useEffect(() => {
    getUserData();
  }, []);

  const getUserData = () => {
    let data = localStorage.getItem("user");
    data = JSON.parse(data);
    dispatch(setUserData(data));
  };
  return (
    <ThemeProvider theme={MUI_THEME}>
      <Routes>
        <Route element={<AuthLayout />}>
          {AuthRoutes.map(({ component: Component, path, id }) => {
            return <Route key={id} path={path} element={Component} />;
          })}
        </Route>
        <Route path="/" element={<ProtectedLayout />}>
          {ADMIN_ROUTES?.map(({ component: Component, path, id }) => (
            <Route key={id} path={path} element={Component} />
          ))}
          <Route
            key={3}
            path="/vendor-profile"
            element={<VendorProfilePage />}
          />
          <Route key={3} path="/Edit-Return-Order" element={<EditReturn />} />
        </Route>
        <Route key={3} path="/support-screen" element={<SupportScreen />} />
        <Route key={3} path="/privacy-policy" element={<PrivacyPolicyPage />} />
      </Routes>
      <SnackbarAlert
        ref={(ref) => {
          constants.snackRef = ref;
        }}
      />
    </ThemeProvider>
  );
}

export default App;
